/*
 * @Author: 阿宇 969718197@qq.com
 * @Date: 2025-03-20 14:58:47
 * @LastEditors: 阿宇 969718197@qq.com
 * @LastEditTime: 2025-03-20 15:58:06
 * @Description:
 */
const langMalay = {
  officialPrice: "Harga Panduan Rasmi",
  price: "Harga",
  quantity: 'Kuantiti',
  buyNow: 'Beli Sekarang',
  addToCart: 'Tambah ke Troli',
  productDetail: 'Butiran Produk',
  product: 'Produk',
  brand: 'Brand',
  productName: 'Nama Produk',
  unit: 'Unit',
  specification: 'Spesifikasi',
  specificationNum: 'Spesifikasi Kuantiti',
  description: 'Penerangan',
  tips: 'Petua',
  dataLoadFailed: 'Data gagal dimuat',
  confirm: 'Sahkan',
  quantityLessThanOne: 'Kuantiti kurang daripada 1',
  addToCartSuccess: 'Ditambah ke Troli',
  addToCartFailed: 'Gagal ditambah ke Troli',
  buyQuantity: 'Kuantiti Pembelian',
};
export default langMalay;
